module.exports = __webpack_public_path__ + "img/logoMatch.76909f16.png";